import { FeatureFlags } from 'shared/services/mappers/mappers';

export type EmploymentTypeFeatureFlags = Pick<
  FeatureFlags,
  'allowFreelancerEmploymentType' | 'allowTempWorkerEmploymentType'
>;

export const areAtLeastTwoEmploymentTypesEnabled = (featureFlags: EmploymentTypeFeatureFlags) =>
  Object.values(featureFlags).filter((value) => value).length >= 2;
